import React, { useState, useEffect } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  InputWrapper,
  ForgotLink,
  ErrorShow, // Import the ErrorShow component
} from "./style";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "./Header";
import logoImg from "../assets/logo/Logo.png";

const ResetPassWord = ({ token }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email"); // Get email from URL
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(true); // Modal open state

  useEffect(() => {
    // Automatically open the modal if token and email are present in the URL
    if (token) {
      setIsOpen(true);
    }
  }, [token]);

  // Function to validate input
  const validate = () => {
    const newErrors = {};
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords don't match";
    }

    return newErrors;
  };

  const handleForgot = async (e) => {
    e.preventDefault();

    // Validate input
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_URL}/reset-password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
          email: email,
          password: password,
          password_confirmation: confirmPassword,
        }),
      }
    );

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem("authToken", JSON.stringify(data.token));
      toast.success("Password reset successful! Redirecting to login page...");
      // Close modal and redirect after 3 seconds
      setTimeout(() => {
        handleClose();
        navigate("/");
      }, 3000);
    } else {
      toast.error("Invalid or expired token.");
    }
  };

  // Handle modal close
  const handleClose = () => {
    setIsOpen(false);
    navigate("/");
  };

  // Return null if modal should not be displayed
  if (!isOpen) return null;

  return (
    <>
      <Header />
      <ModalOverlay />

      <ModalContent>
        <CloseButton onClick={handleClose}>&times;</CloseButton>

        <Form onSubmit={handleForgot}>
          <Title>
            <img width={200} src={logoImg} alt="logo" />
          </Title>
          <InputWrapper>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
            />
            {errors.password && <ErrorShow>{errors.password}</ErrorShow>}
          </InputWrapper>

          <InputWrapper>
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
            {errors.confirmPassword && (
              <ErrorShow>{errors.confirmPassword}</ErrorShow>
            )}
          </InputWrapper>

          <Button type="submit">Reset Password</Button>
        </Form>

        <ForgotLink onClick={handleClose}>Back to Login</ForgotLink>
      </ModalContent>
    </>
  );
};

export default ResetPassWord;
